import { SxProps, Theme } from "@mui/material";
import { timelineOppositeContentClasses } from "@mui/lab/TimelineOppositeContent";

// Shared styling for the step timelines of a stone's analysis page, so its sections read alike.
export const timelineSx: SxProps<Theme> = {
  [`& .${timelineOppositeContentClasses.root}`]: {
    maxWidth: "10px",
  },
  // Each item is only as tall as its own content (no 70px default floor that inflates the
  // short steps), and every content block carries the same vertical padding — so the gutter
  // between consecutive steps is constant while their heights stay free to differ.
  "& .MuiTimelineItem-root": {
    minHeight: 0,
  },
  "& .MuiTimelineContent-root": {
    py: 1,
  },
};
